var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectingTransportingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52603",
    "data-name": "Group 52603",
    transform: "translate(-158 -2838.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18629",
    "data-name": "Rectangle 18629",
    transform: "translate(158 2838.968)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_16_",
    "data-name": "svgexport-7 (16)",
    transform: "translate(168 2849.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52543",
    "data-name": "Group 52543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91026",
    "data-name": "Path 91026",
    d: "M51,2a3.016,3.016,0,0,0-3,3V59a3.016,3.016,0,0,0,3,3h4a3.016,3.016,0,0,0,3-3V5a3.016,3.016,0,0,0-3-3ZM50,38h6v6H50Zm0,8h6v6H50Zm0,8h6v5a.977.977,0,0,1-1,1H51a.977.977,0,0,1-1-1Z",
    fill: "#93a750",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91027",
    "data-name": "Path 91027",
    d: "M9,10a3.016,3.016,0,0,0-3,3v5a3.016,3.016,0,0,0,3,3V59a3.016,3.016,0,0,0,3,3H40a3.016,3.016,0,0,0,3-3V21a3.016,3.016,0,0,0,3-3V13a3.016,3.016,0,0,0-3-3Zm2,11H41V59a.977.977,0,0,1-1,1H12a.977.977,0,0,1-1-1Zm5,8a3.016,3.016,0,0,0-3,3V55a3.016,3.016,0,0,0,3,3H36a3.016,3.016,0,0,0,3-3V32a3.016,3.016,0,0,0-3-3Z",
    fill: "#93a750",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectingTransportingIcon);
export default __webpack_public_path__ + "static/media/CollectingTransportingIcon.5261a8264291687d955d23644ee3337a.svg";
export { ForwardRef as ReactComponent };